import type { User } from "@supabase/supabase-js";

/**
 * True only when the auth user owns a verified email. Freemium signup starts as an anonymous user, and the
 * address stays in `new_email` until the code is verified, so a password set before that locks the user out.
 */
export function hasConfirmedEmail(user: Pick<User, "email" | "email_confirmed_at"> | null | undefined) {
    return Boolean(user?.email && user.email_confirmed_at);
}
